<div style="height: calc(100%); width: 100%;" data-cy="draw-stamp-container">
  <mat-card appearance="outlined" style="width: 100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="draw-stamp-card">
    <span class="configuration-section-title" data-cy="draw-stamp-title">Stamp Tools</span>
    <app-tdo-configuration-action-bar newHidden="true" (saveClick)="onSave($event)" data-cy="draw-stamp-action-bar"></app-tdo-configuration-action-bar>

    <!-- Standard Stamp Section -->
    <mat-card-title data-cy="draw-stamp-standard-title">Stamp Object</mat-card-title>
    <mat-card-subtitle data-cy="draw-stamp-standard-subtitle">Standard stamp default font.</mat-card-subtitle>
    <div data-cy="draw-stamp-standard-example-container">
      <p data-cy="draw-stamp-standard-example-text">Example Text</p>
    </div>

    <table style="width: 618px; border-spacing: 0 8px;" data-cy="draw-stamp-standard-table">
      <!-- Font Settings Row -->
      <tr data-cy="draw-stamp-standard-font-row">
        <td style="width: 200px; height: 50px;" data-cy="draw-stamp-standard-font-field">
          <tdo-dropdown-v2 *ngIf="drawStampDefaults" widthString="200px" placeholder="Font" placeholderPosition="above" [datasource]="enumFonts" displayProperty="name" [value]="getFont(this.drawStampDefaults.fontStdStamp)" (selectionChange)="onFontChangeStd($event); dropdownChange($event);" data-cy="draw-stamp-standard-font-dropdown"></tdo-dropdown-v2>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 40px; height: 50px;" data-cy="draw-stamp-standard-font-size-field">
          <tdo-dropdown-v2 *ngIf="drawStampDefaults" widthString="200px" placeholder="Size" placeholderPosition="above" [datasource]="FontSizes" displayProperty="value" [value]="getFontSize(this.drawStampDefaults.fontSizeStdStamp)" (selectionChange)="onFontSizeChangeStd($event); dropdownChange($event);" data-cy="draw-stamp-standard-font-size-dropdown"></tdo-dropdown-v2>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 200px; height: 50px;" data-cy="draw-stamp-standard-font-style-field">
          <tdo-dropdown-v2 *ngIf="drawStampDefaults" widthString="200px" placeholder="Style" placeholderPosition="above" [datasource]="enumFontStyles" displayProperty="name" [value]="getFontStyle(this.drawStampDefaults.fontStyleStdStamp)" (selectionChange)="onFontStyleChangeStd($event); dropdownChange($event);" data-cy="draw-stamp-standard-font-style-dropdown"></tdo-dropdown-v2>
        </td>
      </tr>

      <!-- Colors Row -->
      <tr data-cy="draw-stamp-standard-colors-row">
        <td style="width: 200px;" data-cy="draw-stamp-standard-foreground-color-field">
          <app-tdo-color-picker label="Foreground Color" style="width: 100%;" placeholder="Foreground color" [color]="foregroundStdStamp" (colorChange)="onForegroundColorChangeStd($event); configurationService.setDirty();" data-cy="draw-stamp-standard-foreground-color-picker"></app-tdo-color-picker>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 40px;" data-cy="draw-stamp-standard-background-color-field">
          <app-tdo-color-picker label="Background Color" style="width: 100%;" placeholder="Background color" [color]="backgroundStdStamp" (colorChange)="onBackgroundColorChangeStd($event); configurationService.setDirty();" data-cy="draw-stamp-standard-background-color-picker"></app-tdo-color-picker>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 200px;"></td>
      </tr>

      <!-- Location Row -->
      <tr data-cy="draw-stamp-standard-location-row">
        <td colspan="5">
          <mat-card-subtitle data-cy="draw-stamp-standard-location-subtitle">Standard stamp location.</mat-card-subtitle>
          <div style="width: 200px; height: 50px;" data-cy="draw-stamp-standard-location-field">
            <tdo-dropdown-v2 *ngIf="drawStampDefaults" widthString="200px" placeholder="Style" placeholderPosition="above" [datasource]="enumStampLocations" displayProperty="name" [value]="getLocation(this.drawStampDefaults.locationStdStamp)" (selectionChange)="onStampLocationChange($event); dropdownChange($event);" data-cy="draw-stamp-standard-location-dropdown"></tdo-dropdown-v2>
          </div>
        </td>
      </tr>
    </table>

    <br />

    <!-- Custom Stamp Section -->
    <mat-card-title data-cy="draw-stamp-custom-title">Custom Stamp Object</mat-card-title>
    <mat-card-subtitle data-cy="draw-stamp-custom-subtitle">Custom stamp default font.</mat-card-subtitle>
    <p data-cy="draw-stamp-custom-example-text">Example Text</p>

    <table style="width: 618px; border-spacing: 0 8px;" data-cy="draw-stamp-custom-table">
      <!-- Font Settings Row -->
      <tr data-cy="draw-stamp-custom-font-row">
        <td style="width: 200px; height: 50px;" data-cy="draw-stamp-custom-font-field">
          <tdo-dropdown-v2 *ngIf="drawStampDefaults" widthString="200px" placeholder="Font" placeholderPosition="above" [datasource]="enumFonts" displayProperty="name" [value]="getFont(this.drawStampDefaults.fontCustomStamp)" (selectionChange)="onFontChangeCustom($event); dropdownChange($event);" data-cy="draw-stamp-custom-font-dropdown"></tdo-dropdown-v2>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 40px; height: 50px;" data-cy="draw-stamp-custom-font-size-field">
          <tdo-dropdown-v2 *ngIf="drawStampDefaults" widthString="200px" placeholder="Size" placeholderPosition="above" [datasource]="FontSizes" displayProperty="value" [value]="getFontSize(this.drawStampDefaults.fontSizeCustomStamp)" (selectionChange)="onFontSizeChangeCustom($event); dropdownChange($event);" data-cy="draw-stamp-custom-font-size-dropdown"></tdo-dropdown-v2>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 200px; height: 50px;" data-cy="draw-stamp-custom-font-style-field">
          <tdo-dropdown-v2 *ngIf="drawStampDefaults" widthString="200px" placeholder="Style" placeholderPosition="above" [datasource]="enumFontStyles" displayProperty="name" [value]="getFontStyle(this.drawStampDefaults.fontStyleCustomStamp)" (selectionChange)="onFontStyleChangeCustom($event); dropdownChange($event);" data-cy="draw-stamp-custom-font-style-dropdown"></tdo-dropdown-v2>
        </td>
      </tr>

      <!-- Colors Row -->
      <tr data-cy="draw-stamp-custom-colors-row">
        <td style="width: 200px;" data-cy="draw-stamp-custom-foreground-color-field">
          <app-tdo-color-picker label="Foreground Color" style="width: 100%;" placeholder="Foreground color" [color]="foregroundCustomStamp" (colorChange)="onForegroundColorChangeCustom($event); configurationService.setDirty();" data-cy="draw-stamp-custom-foreground-color-picker"></app-tdo-color-picker>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 40px;" data-cy="draw-stamp-custom-background-color-field">
          <app-tdo-color-picker label="Background Color" style="width: 100%;" placeholder="Background color" [color]="backgroundCustomStamp" (colorChange)="onBackgroundColorChangeCustom($event); configurationService.setDirty();" data-cy="draw-stamp-custom-background-color-picker"></app-tdo-color-picker>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 200px;"></td>
      </tr>

      <!-- Location Note Row -->
      <tr data-cy="draw-stamp-custom-location-row">
        <td colspan="5">
          <p data-cy="draw-stamp-custom-location-note">
            <mat-card-subtitle data-cy="draw-stamp-custom-location-subtitle">Location of the custom stamp will be the opposite side horizontally from the standard stamp location.</mat-card-subtitle>
          </p>
        </td>
      </tr>
    </table>
  </mat-card>
</div>

